import React, { useContext } from 'react';
import { useMediaQuery } from 'react-responsive';
import { BrandingContext } from '../contexts/ContractContext';
import getClientContent from '../_BrandingProvider/brandContent';
import { stripPhoneNumber } from './util';

const ClientPhone = ({ department, tag = '' }) => {
    // department can be either "claim" or "customerService"
    const context = useContext(BrandingContext);
    const { clientId } = context;

    const isMobile = useMediaQuery({ maxWidth: '767px' });

    const { phone } = getClientContent(clientId).variableText[department];
    const phoneStripped = stripPhoneNumber(phone);

    //Included tag prop inorder to acheive a11y
    if (tag === 'span') {
        return <span className='callLink'>{phone}</span>;
    }

    return (
        <a
            className='callLink'
            href={`tel:${phoneStripped}`}
        >
            {phone}
        </a>
    );
};

export default ClientPhone;
